import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Typography, DialogContentText, Divider, MenuItem, Grid, InputLabel, TextField, TableCell, TableRow, TableContainer, TableBody, Table, Paper } from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import tokenDecoder from '../../../utils/tokenDecoder';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { CustomMultiSelect } from 'src/utils/CustomMultiSelect';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  table: {
    minWidth: 550,
  },
  tableContainer: {
    border: '2px solid #424242',
    borderRadius: '5px',
    padding: theme.spacing(2),

  },
  table: {
    minWidth: 550,
    borderCollapse: 'collapse',
  },
  tableCell: {
    border: '1px solid #424242',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
}));

const screenCode = 'PURCHASEORDERNEW';
export default function PurchaseOrder() {
  const classes = useStyles();
  const navigate = useNavigate();
  const alert = useAlert();
  const [title, setTitle] = useState("Add Purchase Order");
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [isAdd, setIsAdd] = useState(false);
  const [quotationsList, setQuotationsList] = useState([]);
  const [supplliers, setSuppliers] = useState([]);
  const [backConfirmation, setBackConfirmation] = useState(false);
  const [isExecuteButtonDisabled, setIsExecuteButtonDisabled] = useState(false);
  const [selectedDueDate, setSelectedDueDate] = useState(new Date());
  const componentRef = useRef();
  const [requisitions, setRequistions] = useState([]);
  const [purchaseOrderDetails, setPurchaseOrderDetails] = useState({
    groupID: 0,
    factoryID: 0,
    supplierID: 0,
    quotationHeaderID: 0,
    termsAndConditionsID: 0,
    deliveryInstructionsID: 0,
    contactPerson: '',
    remark: '',
    requisitionID: 0
  });
  const [totals, setTotals] = useState({
    totalGrossAmount: 0,
    totalDiscountAmount: 0,
    totalVATAmount: 0,
    totalNetAmount: 0,
  });
  const [supplierDetails, setSupplierDetails] = useState({});
  const [quotationDetails, setQuotationDetails] = useState([]);
  const [poNumbers, setPONumbers] = useState({});
  const [termsandConditions, setTermsandConditions] = useState();
  const [deliveryInstructions, setDeliveryInstructions] = useState();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });

  const [selectedOptions, setSelectedOptions] = useState([]);
  const getOptionLabel = option => `${option.label}`;
  const getOptionDisabled = option => option.value === "foo";
  const handleToggleOption = selectedOptions => setSelectedOptions(selectedOptions);
  const handleClearOptions = () => setSelectedOptions([]);
  const handleSelectAll = isSelected => {
    if (isSelected) {
      setSelectedOptions(quotationsList.map(quotations => ({ label: quotations.quotationNumber, value: quotations.quotationHeaderID })));
    } else {
      handleClearOptions();
    }
  };

  const [selectedRequisitions, setSelectedRequisitions] = useState([]);
  const getOptionLabelRequisition = option => `${option.label}`;
  const getOptionDisabledRequisition = option => option.value === "foo";
  const handleToggleOptionRequisition = selectedRequisitions => setSelectedRequisitions(selectedRequisitions);
  const handleClearOptionsRequisition = () => setSelectedRequisitions([]);
  const handleSelectAllRequisition = isSelected => {
    if (isSelected) {
      setSelectedRequisitions(requisitions.map(quotations => ({ label: quotations.requisitionNumber, value: quotations.requisitionID })));
    } else {
      handleClearOptions();
    }
  };

  const quotationIDs = selectedOptions.length > 0 ? selectedOptions.map(option => parseInt(option.value)) : [];
  const requisitionIDs = selectedRequisitions.length > 0 ? selectedRequisitions.map(option => parseInt(option.value)) : [];

  useEffect(() => {
    trackPromise(getGroupsForDropdown(), getPermissions(), getDeliveryInstructions(), getTermsandConditions());
  }, []);

  useEffect(() => {
    if (purchaseOrderDetails.groupID > 0) {
      trackPromise(getFactoryByGroupID(purchaseOrderDetails.groupID));
    };
  }, [purchaseOrderDetails.groupID]);

  useEffect(() => {
    if (purchaseOrderDetails.groupID > 0 && purchaseOrderDetails.factoryID > 0) {
      trackPromise(GetSuppliersForDropDown());
    };
  }, [purchaseOrderDetails.groupID, purchaseOrderDetails.factoryID]);

  useEffect(() => {
    setSupplierDetails({});
    setQuotationDetails([]);
    setPONumbers({});
  }, [purchaseOrderDetails.supplierID, purchaseOrderDetails.groupID, purchaseOrderDetails.factoryID, purchaseOrderDetails.quotationHeaderID]);

  useEffect(() => {
    if (purchaseOrderDetails.supplierID > 0) {
      trackPromise(getRequisitionbySupplierID());
    };
  }, [purchaseOrderDetails.supplierID]);

  useEffect(() => {
    trackPromise(getQuotationsByRequisition())
  }, [selectedRequisitions]);

  async function getPermissions(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPERCHASEORDERNEW');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setPurchaseOrderDetails({
      ...purchaseOrderDetails,
      groupID: parseInt(tokenService.getGroupIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoryByGroupID(groupID) {
    var response = await services.getFactoryByGroupID(groupID);
    setFactories(response);
  };

  async function getRequisitionbySupplierID() {
    const requisition = await services.getRequisitionbySupplierID(purchaseOrderDetails.factoryID, purchaseOrderDetails.supplierID);
    setRequistions(requisition);
  }

  async function getQuotationsByRequisition() {
    const requisitionIDList = (requisitionIDs.join(','));
    const quotation = await services.getQuotationsByRequisition(requisitionIDList);
    setQuotationsList(quotation);
  }

  async function GetSuppliersForDropDown() {
    const supplliers = await services.GetSuppliersByGroupIDAndFactoryID(purchaseOrderDetails.groupID, purchaseOrderDetails.factoryID);
    const formattedSuppliers = supplliers.map((supplier, index) => ({
      supplierID: index,
      supplierName: supplier
    }));
    setSuppliers(formattedSuppliers);
  }

  async function GeneratePurchaseOrderNumber() {
    const poNumber = await services.GeneratePurchaseOrderNumber(purchaseOrderDetails.groupID, purchaseOrderDetails.factoryID);
    setPONumbers(poNumber.data);
  }

  async function getTermsandConditions() {
    const data = await services.getTermsandConditions();
    setTermsandConditions(data);
  }

  async function getDeliveryInstructions() {
    const data = await services.getDeliveryInstructions();
    setDeliveryInstructions(data);
  }

  function clearData() {
    debugger;
    if (!permissionList.isFactoryFilterEnabled) {
      setPurchaseOrderDetails({
        ...purchaseOrderDetails,
        supplierID: 0,
        quotationHeaderID: 0,
      });
    }
    else {
      setPurchaseOrderDetails({
        ...purchaseOrderDetails,
        factoryID: 0,
        supplierID: 0,
        quotationHeaderID: 0,
      });
    }
    setSelectedRequisitions([]);
    setSelectedOptions([]);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    if (name === 'groupID') {
      setPurchaseOrderDetails({
        ...purchaseOrderDetails,
        groupID: value,
        factoryID: 0,
        supplierID: 0,
        quotationHeaderID: 0,
        requisitionID: 0
      });
      setSupplierDetails({});
      setQuotationDetails([]);
    } else if (name === 'factoryID') {
      setPurchaseOrderDetails({
        ...purchaseOrderDetails,
        factoryID: value,
        supplierID: 0,
        quotationHeaderID: 0,
        requisitionID: 0
      });
      setSupplierDetails({});
      setQuotationDetails([]);
    } else if (name === 'supplierID') {
      setPurchaseOrderDetails({
        ...purchaseOrderDetails,
        supplierID: value,
        quotationHeaderID: 0,
        requisitionID: 0
      });
      setSupplierDetails({});
      setQuotationDetails([]);
    } else if (name === 'quotationHeaderID') {
      setPurchaseOrderDetails({
        ...purchaseOrderDetails,
        quotationHeaderID: value,
      });
      setSupplierDetails({});
      setQuotationDetails([]);
    } else if (name === 'requisitionID') {
      setPurchaseOrderDetails({
        ...purchaseOrderDetails,
        requisitionID: value,
        quotationHeaderID: 0
      });
      setSupplierDetails({});
      setQuotationDetails([]);
    } else {
      setPurchaseOrderDetails({
        ...purchaseOrderDetails,
        [name]: value
      });
    }
  }

  function handleChange1(e) {
    const target = e.target;
    const value = target.value
    setPurchaseOrderDetails({
      ...purchaseOrderDetails,
      [e.target.name]: value
    });
  }

  function onDueDateChange(date) {
    setSelectedDueDate(date);
    setSupplierDetails({});
    setQuotationDetails([]);
  }

  function handleSearchDropdownChangeBuyer(event, value) {
    if (value) {
      setPurchaseOrderDetails((prevState) => ({
        ...prevState,
        supplierID: value.supplierID,
        supplierName: value.supplierName,
        quotationHeaderID: 0,
        requisitionID: 0
      }));
    } else {
      setPurchaseOrderDetails((prevState) => ({
        ...prevState,
        supplierID: 0,
        supplierName: '',
        quotationHeaderID: 0,
        requisitionID: 0
      }));
    }
  }

  async function getData() {
    const quotationIDList = (quotationIDs.join(','));
    const requisitionIDList = (requisitionIDs.join(','));

    let model = {
      groupID: parseInt(purchaseOrderDetails.groupID),
      factoryID: parseInt(purchaseOrderDetails.factoryID),
      supplierID: parseInt(purchaseOrderDetails.supplierID),
      quotationHeaderID: quotationIDList,
      requisitionID: requisitionIDList
    }
    GeneratePurchaseOrderNumber();
    let response = await services.GetSupplierQuotationDetails(model);
    if (response.statusCode == "Success" && response.data.length != 0) {
      calculateTotalValues(response.data.skuDetails);
      setSupplierDetails(response.data.supplierDetails);
      setQuotationDetails(response.data.skuDetails);
    }
    else {
      alert.error("No Records to Display")
    }
  }

  function calculateTotalValues(skuDetails) {

    const totalGrossAmount = skuDetails.reduce((accumulator, current) => accumulator + current.netTotalPrice, 0);
    const totalDiscountAmount = skuDetails[0].discountAmount;
    const totalVATAmount = skuDetails[0].vat;

    const totalNetAmount = totalGrossAmount + totalVATAmount - totalDiscountAmount;

    setTotals({
      ...totals,
      totalGrossAmount: totalGrossAmount,
      totalDiscountAmount: totalDiscountAmount,
      totalVATAmount: totalVATAmount,
      totalNetAmount: totalNetAmount
    })
  }

  async function saveDetails() {

    if (supplierDetails != null || quotationDetails.length > 0) {

      let saveModel = {
        groupID: parseInt(purchaseOrderDetails.groupID),
        factoryID: parseInt(purchaseOrderDetails.factoryID),
        supplierID: parseInt(purchaseOrderDetails.supplierID),
        poNumber: poNumbers.newPONum,
        quotationHeaderID: quotationDetails[0]?.quotationHeaderID || 0,
        quotationNumber: quotationDetails[0].quotationNumber,
        supplierID: parseInt(purchaseOrderDetails.supplierID),
        supplierVATNo: supplierDetails.supplierVATNo,
        supplierSVATNo: supplierDetails.supplierSVATNo,
        companyVATNo: quotationDetails[0]?.companyVatNo || "",
        companySVATNo: quotationDetails[0]?.companySvatNo || "",
        orderDate: moment(new Date()).format("YYYY-MM-DD"),
        dateOfDelivery: moment(selectedDueDate).format("YYYY-MM-DD"),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdDate: new Date().toISOString(),
        requisitionID: parseInt(purchaseOrderDetails.requisitionID),
        requisitionNumber: quotationDetails[0]?.requisitionNumber || "",
        factoryID: quotationDetails[0]?.factoryID || 0,
        grossAmount: totals?.totalGrossAmount || 0,
        discount: quotationDetails[0].discountAmount,
        vat: totals?.totalVATAmount || 0,
        netAmount: totals?.totalNetAmount || 0,
        deliveryInstructionID: parseInt(purchaseOrderDetails.deliveryInstructionsID),
        deliveryInstructions: quotationDetails[0]?.deliveryInstructions || "",
        termsAndConditionsID: purchaseOrderDetails.termsAndConditionsID,
        termsAndConditions: quotationDetails[0]?.termsAndConditions || "",
        contactPerson: purchaseOrderDetails.contactPerson || "",
        evaluationNo: quotationDetails[0]?.evaluationNo || "",
        remark: purchaseOrderDetails.remark || "",
        SkuList: quotationDetails,
      }
      var response = await services.SavePurchaseOrderDetails(saveModel);
      if (response.statusCode == "Success") {
        alert.success("PURCHASE ORDER GENERATED SUCCESSFULLY");
        clearData();
      }
      else {
        alert.error(response.message);
      }
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page
        className={classes.root}
        title={title}
      >
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: purchaseOrderDetails.groupID,
              factoryID: purchaseOrderDetails.factoryID,
              supplierID: purchaseOrderDetails.supplierID,
              quotationHeaderID: selectedOptions,
              requisitionID: selectedRequisitions
            }}

            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                supplierID: Yup.number().required('Supplier is required').min("1", 'Supplier is required'),
                quotationHeaderID: Yup.array().required('Please select at least one Quotation').min(1, 'Please select at least one Quotation'),
                requisitionID: Yup.array().required('Please select at least one Requisition').min(1, 'Please select at least one Requisition'),
              })
            }
            onSubmit={getData}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent style={{ marginBottom: "2rem" }}>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group  *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              helperText={touched.groupID && errors.groupID}
                              fullWidth
                              name="groupID"
                              onChange={(e) => handleChange(e)}
                              value={purchaseOrderDetails.groupID}
                              variant="outlined"
                              size="small"
                              onBlur={handleBlur}
                              InputProps={{
                                readOnly: !permissionList.isGroupFilterEnabled || isAdd,
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              value={purchaseOrderDetails.factoryID}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{ readOnly: !permissionList.isFactoryFilterEnabled }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="supplierID">
                              Supplier *
                            </InputLabel>
                            <Autocomplete
                              id="supplierID"
                              options={supplliers || []}
                              size="small"
                              clearOnBlur={false}
                              getOptionLabel={(option) => option?.supplierName || ''}
                              onChange={(event, value) => {
                                setFieldValue('supplierID', value ? value.supplierID : '');
                                handleSearchDropdownChangeBuyer(event, value);
                                handleChange({ target: { name: 'supplierID', value: value ? value.supplierID : '' } });
                              }}
                              value={
                                (supplliers && supplliers.find((supplier) => supplier?.supplierID === purchaseOrderDetails.supplierID)) || null
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={Boolean(touched.supplierID && errors.supplierID)}
                                  helperText={touched.supplierID && errors.supplierID}
                                  variant="outlined"
                                  placeholder="--Select Supplier--"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="requisitionID">
                              Requisition Number *
                            </InputLabel>
                            <CustomMultiSelect
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              helperText={touched.factoryID && errors.factoryID}
                              items={requisitions.map(quotations => ({ label: quotations.requisitionNumber, value: quotations.requisitionID }))}
                              getOptionLabel={getOptionLabelRequisition}
                              getOptionDisabled={getOptionDisabledRequisition}
                              selectedValues={selectedRequisitions}
                              placeholder="Select Requisition"
                              selectAllLabel="Select all"
                              onToggleOption={handleToggleOptionRequisition}
                              onClearOptions={handleClearOptionsRequisition}
                              onSelectAll={handleSelectAllRequisition}
                              limitTags={1}
                              onBlur={handleBlur}
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="quotationHeaderID">
                              Quotation Number *
                            </InputLabel>
                            <CustomMultiSelect
                              error={Boolean(touched.quotationHeaderID && errors.quotationHeaderID)}
                              helperText={touched.quotationHeaderID && errors.quotationHeaderID}
                              items={quotationsList.map(quotations => ({ label: quotations.quotationNumber, value: quotations.quotationHeaderID }))}
                              getOptionLabel={getOptionLabel}
                              getOptionDisabled={getOptionDisabled}
                              selectedValues={selectedOptions}
                              placeholder="Select Quotation"
                              selectAllLabel="Select all"
                              onToggleOption={handleToggleOption}
                              onClearOptions={handleClearOptions}
                              onSelectAll={handleSelectAll}
                              limitTags={1}
                              onBlur={handleBlur}
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink>
                              Delivery Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                id="date-picker-inline"
                                name='startDate'
                                value={selectedDueDate}
                                minDate={new Date()}
                                onChange={(date) => onDueDateChange(date)}
                                autoOk
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                size='small'
                                variant='inline'
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container justify="flex-end" spacing={3}>
                          <Box pr={2} style={{ marginTop: '20px' }}>
                            <Button
                              color="primary"
                              variant="outlined"
                              type="reset"
                              onClick={clearData}
                              size='small'
                            >
                              Clear
                            </Button>
                          </Box>
                          <Box pr={2} style={{ marginTop: '20px' }}>
                            <Button
                              color="primary"
                              variant="contained"
                              type="submit"
                              size='small'
                              disabled={isExecuteButtonDisabled}
                            >
                              {"Search"}
                            </Button>
                          </Box>
                        </Grid>
                      </CardContent>
                      {(supplierDetails.length > 0 || quotationDetails.length > 0) ? (
                        <>
                          <hr style={{ border: "1px solid black" }} />
                          <Typography variant="h5" style={{ marginLeft: '10px', margin: '10px', fontWeight: 'bold', textAlign: "right", marginRight: "10px", fontSize: "18px" }}>
                            Purchase Order : {poNumbers?.newPONum} &nbsp;&nbsp;&nbsp; Delivery Date : {moment(selectedDueDate).format("YYYY-MM-DD")}
                          </Typography>
                          <hr style={{ border: "1px solid black" }} />
                          <Grid container spacing={2} style={{ marginTop: 20 }}>
                            <Grid item xs={6}>
                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableBody>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Supplier Name</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.supplierName || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Address</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.supplierAddress || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Tel No.</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.contactNumber || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Supplier VAT No.</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.supplierVATNo || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Supplier SVAT No.</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.supplierSVATNo || "-"}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                            <Grid item xs={6}>
                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableBody style={{ border: "1px solid black" }}>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Date</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{moment(new Date()).format("YYYY-MM-DD")}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Name of Factory</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{quotationDetails[0]?.factoryName || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}>
                                        <b>Req. No</b>
                                      </TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>
                                        <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                          {[...new Set(quotationDetails.map(item => item.requisitionNumber))].map((reqNo, index) => (
                                            <li key={index}>{reqNo}</li>
                                          ))}
                                        </ul>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Company VAT No</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{quotationDetails[0]?.companyVatNo || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Company SVAT No</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{quotationDetails[0]?.companySvatNo || "-"}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                          </Grid>

                        </>
                      ) : null}
                      {(supplierDetails.length > 0 || quotationDetails.length > 0) ? (
                        <Grid>
                          <TableContainer component={Paper} style={{ marginTop: 30 }}>
                            <Table size="small" style={{ border: "1px solid black" }}>
                              <TableBody style={{ border: "1px solid black" }}>
                                <TableRow style={{ border: "1px solid black" }}>
                                  <TableCell style={{ border: "1px solid black" }}><b>Item Code</b></TableCell>
                                  <TableCell style={{ border: "1px solid black" }}><b>Description</b></TableCell>
                                  <TableCell style={{ border: "1px solid black" }}><b>Unit</b></TableCell>
                                  <TableCell style={{ border: "1px solid black" }}><b>Quantity</b></TableCell>
                                  <TableCell style={{ border: "1px solid black" }} align="center"><b>Unit Price</b></TableCell>
                                  <TableCell style={{ border: "1px solid black" }} align="center"><b>Total</b></TableCell>
                                </TableRow>
                                {quotationDetails.length > 0 ? quotationDetails.map((item, index) => (
                                  <TableRow key={index} style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}>{item.skuCode || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }}>{item.skuMasterName || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }}>{item.unit || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }}>{Number(item.requestedQuantity).toLocaleString("en-US") || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(item.requestedUnitPrice).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(item.netTotalPrice).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}</TableCell>
                                  </TableRow>
                                )) : <TableRow style={{ border: "1px solid black" }}><TableCell colSpan={6} align="center">No items available</TableCell></TableRow>}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      ) : null}
                      <Box display="flex" flexDirection="column">
                        {(supplierDetails.length > 0 || quotationDetails.length > 0) ? (
                          <Grid>
                            <TableContainer component={Paper} style={{ marginTop: 20, width: "50%", float: "right" }}>
                              <Table size="small" style={{ border: "1px solid black" }}>
                                <TableBody>
                                  <TableRow style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}><b>Gross Amount</b></TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(totals?.totalGrossAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00"}</TableCell>
                                  </TableRow>
                                  <TableRow style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}><b>Discount</b></TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(totals?.totalDiscountAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00"}</TableCell>
                                  </TableRow>
                                  <TableRow style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}><b>Net Amount</b></TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(totals?.totalNetAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00"}</TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        ) : null}

                        {quotationDetails.length > 0 || supplierDetails.length > 0 ? (
                          <Grid item xs={6}>
                            <TableContainer>
                              <Table size="small">
                                <TableBody>
                                  <TableRow >
                                    <TableCell><b>Delivery Instructions :</b></TableCell>
                                    <TableCell>
                                      <TextField select
                                        fullWidth
                                        name="deliveryInstructionsID"
                                        onChange={(e) => handleChange(e)}
                                        value={purchaseOrderDetails.deliveryInstructionsID}
                                        variant="outlined"
                                        size="small"
                                        onBlur={handleBlur}
                                      >
                                        <MenuItem value="0">--Select Delivery Instructions--</MenuItem>
                                        {generateDropDownMenu(deliveryInstructions)}
                                      </TextField>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow >
                                    <TableCell><b>Terms and Conditions :</b></TableCell>
                                    <TableCell>
                                      <TextField select
                                        fullWidth
                                        name="termsAndConditionsID"
                                        onChange={(e) => handleChange(e)}
                                        value={purchaseOrderDetails.termsAndConditionsID}
                                        variant="outlined"
                                        size="small"
                                        onBlur={handleBlur}
                                      >
                                        <MenuItem value="0">--Select Terms and Conditions--</MenuItem>
                                        {generateDropDownMenu(termsandConditions)}
                                      </TextField>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell><b>Remark :</b></TableCell>
                                    <TableCell>
                                      <TextField
                                        fullWidth
                                        size='small'
                                        name="remark"
                                        onBlur={handleBlur}
                                        onChange={(e) => handleChange1(e)}
                                        value={purchaseOrderDetails.remark}
                                        variant="outlined"
                                        inputProps={{ maxLength: 20 }}
                                      /></TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell><b>Contact Person :</b></TableCell>
                                    <TableCell>
                                      <TextField
                                        fullWidth
                                        size='small'
                                        name="contactPerson"
                                        onBlur={handleBlur}
                                        onChange={(e) => handleChange1(e)}
                                        value={purchaseOrderDetails.contactPerson}
                                        variant="outlined"
                                        inputProps={{ maxLength: 20 }}
                                      /></TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        ) : null}

                        {quotationDetails.length > 0 || supplierDetails.length > 0 ? (
                          <Box display="flex" justifyContent="flex-end" p={5}>
                            <Button
                              color="primary"
                              type="button"
                              variant="contained"
                              disabled={quotationDetails[0].statusID == 5}
                              size='small'
                              onClick={() => saveDetails()}
                            >
                              {"Generate PO"}
                            </Button>
                          </Box>
                        ) : null}
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
        <Dialog open={backConfirmation}>
          <DialogTitle id="alert-dialog-slide-title">
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h3">
              <Box textAlign="center">
                Confirmation
              </Box>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <Typography variant="h5">Are you sure do you want to go back without saving?</Typography>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <br />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
          </DialogActions>
        </Dialog>
      </Page >
    </Fragment >
  )
}
